export default __webpack_public_path__ + "static/media/next-artisanpro.f3d634aa.jpg";